'use strict';
var $ = require('jquery');

function init() {
    var importArea = $("#current-import-export");

    if (importArea.length > 0) {
        setTimeout(function () {
            document.location.reload();
        }, 5000);
    }
}

module.exports = {
    init: init
};
